import React, { useEffect, useState } from "react";
import { Add } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { toast } from "react-toastify";

import FormDrawer from "components/Shared/FormDrawer";
import ShipmentTransitBranchForm from "./ShipmentTransitBranchForm";
import ShipmentTransitBranchList from "./ShipmentTransitBranchList";
import { useShipmentDetailContext } from "contexts/ShipmentDetailContext";

import { useAuth } from "hooks";
import { useAddShipmentTransitBranchMutation, useLazyListShipmentTransitBranchesQuery } from "store/services/shipmentApi";

const ShipmentTransitBranchTab = () => {
    const { isCustomer, isVendor, isContractor, isDriver, isVendorStaff } = useAuth();
    const canEdit = isCustomer || isVendor || isContractor || isDriver || isVendorStaff;

    const [showTransitForm, setShowTransitForm] = useState(false);
    const { ShipmentDetail } = useShipmentDetailContext();
    const shipmentId = ShipmentDetail?._id;

    const [fetchTransitBranches, { data: transitBranchesRes, isLoading: loadingTransitBranches }] =
        useLazyListShipmentTransitBranchesQuery();
    const [addTransitBranch, { isLoading: addingTransitBranch }] =
        useAddShipmentTransitBranchMutation();

    const handleCancelTransit = () => {
        setShowTransitForm(false);
    };

    const handleAddTransitBranch = async (data) => {
        try {
            if (!data.transitBranch) {
                toast.error("Transit branch is required");
                return;
            }

            await addTransitBranch({
                shipmentId: data.shipmentId,
                transitBranch: data.transitBranch,
            }).unwrap();

            toast.success("Transit branch added successfully!");
            handleCancelTransit();
            fetchTransitBranches({ shipmentId });
        } catch (err) {
            toast.error(err?.data?.message ?? "Couldn't add transit branch!");
        }
    };

    useEffect(() => {
        if (shipmentId) {
            fetchTransitBranches({ shipmentId });
        }
    }, [shipmentId, fetchTransitBranches]);

    return (
        <>
            {/* {!canEdit && (
                <Box display="flex" justifyContent="end" padding={3}>
                    {!showTransitForm && (
                        <Button
                            startIcon={<Add />}
                            variant="outlined"
                            disabled={ShipmentDetail?.isActive === false}
                            onClick={() => setShowTransitForm(true)}
                        >
                            Add Transit Branch
                        </Button>
                    )}
                </Box>
            )} */}

            <ShipmentTransitBranchList
                transitBranches={transitBranchesRes || []}
                isLoading={loadingTransitBranches}
            />

            <FormDrawer
                title="Add Transit Branch"
                open={showTransitForm}
                onClose={handleCancelTransit}
            >
                <ShipmentTransitBranchForm
                    isBusy={addingTransitBranch}
                    shipmentId={shipmentId}
                    onCancel={handleCancelTransit}
                    onSubmit={handleAddTransitBranch}
                />
            </FormDrawer>
        </>
    );
};

export default ShipmentTransitBranchTab;